module.exports = __webpack_public_path__ + "static/media/ask-for-feedback.d7e958d4.png";